import { Droppable, Draggable } from "@hello-pangea/dnd";
import CustomSVG from "../../components/UniversalComponents/CustomSVG";
import ToggleSwitch from "../UniversalComponents/SwitchButton";
import ConfirmationDialogMulti from "../UniversalComponents/ConfirmationDialogMulti";
import InfoButton from "../UniversalComponents/InfoButton";
import { useState } from "react";

const InputDrawer = ({
  inputs,
  setSectionNameModal,
  inputPermissionList,
  setInputPermissionList,
  disabled = false,
  customApiData,
  handleUpdateTemplatePermission = () => {},
}) => {
  const [showWarningConvertToSingle, setShowWarningConvertToSingle] = useState({
    show: false,
    data: { type: null, id: null },
  });

  const handleToggleSwitch = ({ data, result }) => {
    handleUpdateTemplatePermission(data, result);
    setInputPermissionList((prev) => {
      const updatedList = [...prev];
      const index = updatedList.findIndex((item) => item.label === data.label);
      updatedList[index] = { ...updatedList[index], value: result };
      return updatedList;
    });
  };

  return (
    <div
      className={`flex flex-col justify-between px-4 py-1 bg-primary-hover w-full  h-full ${disabled && "pointer-events-none"}`}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <p className=" pt-2 mb-1  text-md text-[#131313CC] flex items-center text-base justify-start  ">Add Fields</p>
          <Droppable droppableId="INPUT_DRAWER" isDropDisabled={false} type="INPUT">
            {(provided) => (
              <div className="grid grid-cols-2 gap-3" ref={provided.innerRef} {...provided.droppableProps}>
                {inputs.map((input, index) => (
                  <Draggable key={input.inputType} draggableId={input.inputType} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="flex items-center justify-start gap-2 border rounded-md px-3 py-2 text-sm font-normal cursor-pointer transition group hover:border-primary hover:bg-primary-hover bg-white border-[#E3E3E3] hover:text-primary text-[#131313CC]/80"
                      >
                        {input?.svg && (
                          <CustomSVG
                            svg={input?.svg}
                            width="w-5"
                            height="h-5"
                            color="fill-[#131313CC] group-hover:fill-primary"
                            className="transition group-hover:primary text-[#131313CC]"
                          />
                        )}
                        <span className="group-hover:text-primary transition text-sm text-[#131313CC]">
                          {input.inputName}
                        </span>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          {/* Add section button */}
          <div className="flex items-center justify-center w-full">
            <button
              onClick={() => setSectionNameModal(true)}
              disabled={disabled}
              className="flex w-full justify-center  px-3 py-2 items-center gap-2 mt-4 cursor-pointer group hover:text-primary text-primary hover:bg-primary-hover bg-white border border-[#E3E3E3] hover:border-primary rounded-md"
            >
              + Add Section
            </button>
          </div>
        </div>
        {/* <div className="">
          <p className="mb-2 text-md">Permissions</p>
          <div className="flex flex-col gap-3">
            {inputPermissionList
              .filter((permission) => permission.showInInputSection)
              .map((permission, index) => {
                return (
                  <div key={index} className="flex items-center justify-between p-2 bg-primary-active rounded-md">
                    <p className="text-sm">{permission?.label}</p>
                    <div>
                      <ToggleSwitch
                        checked={permission?.value}
                        onChange={(isChecked) => handleToggleSwitch({ data: permission, result: isChecked })}
                        showText={false}
                        fillColor="var(--color-primary)"
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div> */}
      </div>

      <div className="flex flex-col gap-2">
        <p>Settings</p>
        <div className={`flex items-center hover:opacity-85 rounded-md cursor-not-allowed`}>
          <div className="w-full flex items-center justify-between p-2 bg-primary-active rounded-md">
            <p className="text-sm text-gray-500">Only Company Level</p>
            <div>
              <ToggleSwitch
                disabled
                checked={customApiData?.onlyCompanyLevel}
                onChange={(isChecked) => {
                  handleUpdateTemplatePermission({ label: "onlyCompanyLevel" }, isChecked);
                }}
                showText={false}
                fillColor="var(--color-primary)"
              />
            </div>
          </div>
        </div>
        <div className={`flex items-center hover:opacity-85 rounded-md cursor-not-allowed`}>
          <div className="w-full flex items-center justify-between p-2 bg-primary-active rounded-md">
            <p className="text-sm text-gray-500">Allow Multiple Records</p>
            <div>
              <ToggleSwitch
                disabled
                checked={customApiData?.isMultiRecord}
                onChange={(isChecked) => {
                  if (!isChecked) {
                    setShowWarningConvertToSingle({
                      show: true,
                      label: "multipleRecords",
                      result: isChecked,
                    });
                  } else {
                    handleUpdateTemplatePermission({ label: "multipleRecords" }, isChecked);
                  }
                }}
                showText={false}
                fillColor="var(--color-primary)"
              />
            </div>
          </div>
        </div>
      </div>

      {showWarningConvertToSingle?.show && (
        <ConfirmationDialogMulti
          open={showWarningConvertToSingle?.show}
          onClose={() => {
            setShowWarningConvertToSingle({ show: false, type: null, data: null });
          }}
          title="Revert Multi-Record ?"
          message="Converting Multiple Record to Single Record will delete all the existing data. Are you sure you want to continue ? This action cannot be undone."
          onConfirm={() => {
            handleUpdateTemplatePermission({ label: "multipleRecords" }, showWarningConvertToSingle?.result);
            setShowWarningConvertToSingle({ show: false, type: null, data: null });
          }}
          onCancel={() => {
            setShowWarningConvertToSingle({ show: false, type: null, data: null });
          }}
          confirmVariant="delete"
          cancelVariant="secondary"
          confirmText="Revert"
          cancelText="Cancel"
          iconVariant="delete"
        />
      )}
    </div>
  );
};

export default InputDrawer;
